import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, finalize } from 'rxjs'

import { ApiOmnichannelTimelineService } from '../api/api-omnichannel-timeline.service'
import { IClientEvent } from '../../interfaces/client-event.interface'
import { ITimelineFilters } from '../../interfaces/timeline-filters.interface'

@Injectable({ providedIn: 'root' })
export class OmnichannelTimelineViewService {
  private eventsSubject = new BehaviorSubject<IClientEvent[]>([])
  public events$: Observable<IClientEvent[]> = this.eventsSubject.asObservable()

  private loadingSubject = new BehaviorSubject<boolean>(false)
  public loading$: Observable<boolean> = this.loadingSubject.asObservable()

  //* loadingMore: estado independiente para la paginación ("Cargar más"),
  //* así el filtro/carga inicial usa loading$ (área de cards) y la paginación
  //* solo gira el botón sin ocultar la lista ya cargada.
  private loadingMoreSubject = new BehaviorSubject<boolean>(false)
  public loadingMore$: Observable<boolean> = this.loadingMoreSubject.asObservable()

  private currentClientId: string | null = null
  private currentFilters: ITimelineFilters = { page: 1, limit: 50 }
  private totalCount = 0

  constructor(private api: ApiOmnichannelTimelineService) {}

  load(clientId: string, filters: ITimelineFilters = { page: 1, limit: 50 }): void {
    this.currentClientId = clientId
    this.currentFilters = filters
    this.loadingSubject.next(true)
    this.api
      .getTimeline(clientId, filters)
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe({
        next: (r) => {
          const payload = r?.data ?? ({} as any)
          this.eventsSubject.next(payload.data ?? [])
          this.totalCount = payload.totalItems ?? 0
        },
        error: () => {
          this.eventsSubject.next([])
          this.totalCount = 0
        },
      })
  }

  //* load-more: agrega al subject existente (no reemplaza)
  loadMore(): void {
    if (!this.currentClientId) return
    const filters = { ...this.currentFilters, page: (this.currentFilters.page ?? 1) + 1 }
    this.currentFilters = filters
    this.loadingMoreSubject.next(true)
    this.api
      .getTimeline(this.currentClientId, filters)
      .pipe(finalize(() => this.loadingMoreSubject.next(false)))
      .subscribe({
        next: (r) => {
          const payload = r?.data ?? ({} as any)
          this.eventsSubject.next([...this.eventsSubject.getValue(), ...(payload.data ?? [])])
          this.totalCount = payload.totalItems ?? this.totalCount
        },
      })
  }

  reload(filters: ITimelineFilters): void {
    if (this.currentClientId) this.load(this.currentClientId, { ...filters, page: 1 })
  }

  clear(): void {
    this.eventsSubject.next([])
    this.currentClientId = null
    this.totalCount = 0
  }

  get hasMore(): boolean {
    return this.eventsSubject.getValue().length < this.totalCount
  }
}
